export default __webpack_public_path__ + "static/media/file-folder_darkGray3.579f0218.svg";